(ns ui.data.account.event
  (:require [re-frame.core :as rf]
            [ui.data.account.sub :as sub]))

(rf/reg-event-fx
 ::set-role
 (fn [{db :db} [_ new-role]]
   {:db (-> db
            (assoc ::sub/role new-role))}))
